import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import { getAccounts, deleteChartOfAccount, getChartOfAccountById } from "../api/apiAccountingConfiguration";
import { getSpecificClients } from "views/clients/api/apiClients";
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateOrUpdateChartOfAccount from './CreateOrUpdateChartOfAccount'
import ConfirmationDialog from "common/components/ConfirmationDialog";
import SelectClient from "common/components/custom/SelectClient";

class ChartOfAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            specificsClients: [],
            selectedClient: null,
            accounts: [],
            isOpen: false,
            chartOfAccountToEdit: null,
            chartOfAccountToDelete: null,
            dialogOpen: false,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getAccounts(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value, activePage: 0 }, () => this.getAccounts(this.state.activePage, this.state.selectedClient.id))
    };

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getAccounts(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getAccounts(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getAccounts = (page, selectedClient) => {
        getAccounts({ params: { page: page, size: this.state.rowsPerPage } }, selectedClient).then((response) => {
            this.setState({
                accounts: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getAccounts(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getChartOfAccountById = (id) => {
        getChartOfAccountById(id).then(response => {
            this.setState({ chartOfAccountToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_account_by_id"), { variant: 'error' });
        });
    }

    closeDialog = () => {
        this.setState({ isOpen: false, chartOfAccountToEdit: null });
    }

    deleteChartOfAccount = () => {
        let { chartOfAccountToDelete } = this.state
        deleteChartOfAccount(chartOfAccountToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_account", { accountName: chartOfAccountToDelete.account }), { variant: 'success' });
            this.setState({ dialogOpen: false, chartOfAccountToDelete: null, rowsPerPage: this.state.rowsPerPage }, () => this.getAccounts(0, this.state.selectedClient.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_chart_of_account"), { variant: 'error' });
        });
    }

    render() {

        let { isLoading, specificsClients, selectedClient, accounts, isOpen, chartOfAccountToDelete, dialogOpen } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let accountsList;
        let recordsNotFound;
        if (accounts && accounts.length > 0) {
            accountsList = accounts.map((account, index) => {
                return <TableRow key={index}>
                    <TableCell style={account.account.length === 1 ? { textIndent: '10px' } : account.account.length === 2 ? { textIndent: '20px' } : account.account.length === 3 ? { textIndent: '30px' } : account.account.length === 4 ? { textIndent: '40px' } : account.account.length >= 5 ? { textIndent: '50px' } : null}>{account.account}</TableCell>
                    <TableCell>{account.description}</TableCell>
                    <TableCell>{account.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getChartOfAccountById(account.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ chartOfAccountToDelete: account, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card /* style={{ height: 'calc(100vh - 180px)' }} */>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={6} sm={6} md={4} lg={3} xl={3}>
                                <Grid container direction="row">
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                            {selectedClient !== null && <Grid item container direction="column" xs={6} sm={6} md={8} lg={9} xl={9} >
                                <Grid container direction="row" justifyContent="flex-end">
                                    <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ chartOfAccountToEdit: null, isOpen: true })}>
                                        {this.props.t("add_new_account")}
                                    </Button>
                                </Grid>
                            </Grid>}
                        </Grid>
                        {selectedClient !== null && <TablePagination
                            component="div"
                            count={this.state.totalElements}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            page={this.state.activePage}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={this.state.rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            backIconButtonText={this.props.t("previous_page")}
                            labelRowsPerPage={this.props.t("rows_per_page")}
                            nextIconButtonText={this.props.t("next_page")}
                        />}
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("account")}</TableCell>
                                                        <TableCell component="th" scope="row" width="55%">{this.props.t("description")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {accountsList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateChartOfAccount
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                chartOfAccountToEdit={this.state.chartOfAccountToEdit ? this.state.chartOfAccountToEdit : null}
                getAccounts={() => this.getAccounts(this.state.activePage, selectedClient.id)}
            />
            {
                chartOfAccountToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_chart_of_account")}
                    message={this.props.t("delete_dialog_message_chart_of_account", { name: chartOfAccountToDelete.account })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteChartOfAccount())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid>
    }
}

export default withSnackbar(withTranslation()(ChartOfAccount))